import fakeFetch from './fakeFetch'

export { fakeFetch as default }